var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-16 -21) translate(16 21)"},React.createElement("g",null,React.createElement("path",{"d":"M11.95 0.636L13.364 2.05 8.414 7 13.364 11.95 11.95 13.364 7 8.414 2.05 13.364 0.636 11.95 5.586 7 0.636 2.05 2.05 0.636 7 5.586z","transform":"translate(5 5)"}))))));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
